import {
  boldFont,
  getRelativeFontSize,
  mediumFont,
} from "../../../utils/styles";

const AttendanceStyles = {
  statusBox: {
    border: "1px solid #EEEFF2",
    borderRadius: "8px",
    padding: "10px",
    width: "220px",
  },
  boxStyle: {
    display: "flex",
    padding: "10px",
    flexDirection: "column",
    gap: "10px",
  },
  textMargin: {
    ...boldFont,
    color: "gray",
    fontSize: getRelativeFontSize(0),
  },
  available: {
    ...boldFont,
    lineHeight: 1.2,
    fontSize: getRelativeFontSize(10),
    color: "black",
  },
  total: {
    ...mediumFont,
    lineHeight: 1.2,
    fontSize: getRelativeFontSize(),
    color: "black",
  },
  borderRadiusStyle: {
    border: "none",
    background: "red",
  },

  indicBox: {},
};

export default AttendanceStyles;
